module.exports = __webpack_public_path__ + "7af12d1201ece3f50fe57952ca96333c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-16.png
// module id = 3106
// module chunks = 0